<div app-theme *ngIf="bookToSearch$ | async as bookToSearch" class="app-theme">
    <ng-container *ngIf="bookList$ | async as bookList">
        <div class="flex-row justify-between book-list" infiniteScroll [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50" (scrolled)="onScroll(bookToSearch, bookList)"
            *ngIf="bookList && bookList.length">
            <div *ngFor="let book of bookList" class="inline-block m-5">
                <div class="rounded w-60 h-auto p-3 book-single">
                    <a href="{{book.volumeInfo.previewLink}}" target="_blank">
                        <figure>
                            <img src="{{book.volumeInfo.imageLinks?.thumbnail}}" class="w-auto h-auto m-3" alt="">
                            <figcaption>
                                <div class="overflow-hidden overflow-ellipsis">{{book.volumeInfo.title}}</div>
                                <div class="">{{book.volumeInfo.authors}}</div>
                                <div class="flex flex-col">
                                    <div class="flex flex-row">
                                        <div class="flex mt-2 mb-4 align-items-center">
                                            <span
                                                *ngFor="let star of numSequence(book.volumeInfo.averageRating, 'rating')">
                                                <svg class="mx-1 w-3 h-3 fill-current text-yellow-500"
                                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                                                </svg>
                                            </span>
                                            <span
                                                *ngFor="let star of numSequence(book.volumeInfo.averageRating, 'nonRating')"><svg
                                                    class="mx-1 w-3 h-3 fill-current text-gray-400"
                                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                                                </svg></span>
                                        </div>
                                        <div class="ml-2" style="font-size: 14px;"
                                            *ngIf="book.volumeInfo.ratingsCount > 0">
                                            ({{book.volumeInfo.ratingsCount}})</div>
                                    </div>
                                </div>
                            </figcaption>
                        </figure>
                    </a>
                    <div *ngIf="booksInFav$ | async as booksInFav">
                        <button class="bg-blue-500 hover:bg-blue-700 font-bold py-2 px-4 rounded text-white"
                            (click)="addToFav(book)" *ngIf="!booksInFavId.includes(book.id); else addedToFav">
                            Add To Favourites
                        </button>
                        <ng-template #addedToFav>
                            <button class="bg-green-500 hover:bg-green-700 font-bold py-2 px-4 rounded text-white">
                                Added To Favourites
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>


<!-- <ng-template #searchBooksInput>
    <div app-theme class="app-theme" style="height: 91vh;">
        <div class="relative w-96 m-auto top-72">
            <input class="rounded w-96 py-2 px-10 leading-tight focus:shadow-outline search-books-input text-black"
                type="text" [(ngModel)]="bookName" placeholder="search books here" (keyup.enter)="searchBooks()">
            <i class="fa fa-search absolute top-3 right-6" aria-hidden="true"></i>
        </div>
    </div>
</ng-template> -->